import * as Sentry from '@sentry/react'

const logMessage = Sentry.captureMessage
const logError = Sentry.captureException
const logEvent = Sentry.captureEvent
const logBreadcrumb = Sentry.addBreadcrumb

export { logMessage, logError, logEvent, logBreadcrumb }
